import React, { useEffect, useState } from "react";

import { Button, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Nav } from "../../components/Interface";
import { Table } from '../../components/Global';
import { MuiRouterLink, OutlinedFab } from "../../components/CustomMui";
import api from "../../utils/api";


/**
 * 
 * @todo
 * 
 * Move Table container styles to table? (may not be possible due to "no results" behavior?)
 * 
 */
const useStyles = makeStyles((theme) => ({
  tableContainer: {
    backgroundColor: theme.palette.neutral.light2,
    padding: '32px 30px',
    overflow: 'auto',
    width: '100%',
    boxSizing: "border-box",
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 75px)',
    '& .MuiTextField-root': {
      marginTop: 0,
      marginRight: 0,
    },
    '& .MuiToolbar-root': {
      minHeight: 0,
      padding: '0 2px 0 7px',
    }
  },
  button: {
    alignSelf: 'flex-start',
    '& i[class*="fa"]': {
      fontSize: 16
    },
    '&:hover': {
      color: 'white',
      backgroundColor: theme.palette.primary.hover,
      textDecoration: 'none',
    }
  },
  spinner: {
    margin: '0 auto',
    alignSelf: 'center',
  }
}));

const renderRowData = data => <Typography noWrap={true}>{data}</Typography>;

export const Users = (props) => {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    document.title = "Users | PAVILION Interactive Builder";
  }, []);

  useEffect(() => {
    api.getUsers()
      .then((res) => {
        setUsers(res.data)
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response)
        } else {
          console.log(err)
        }
      })
      .finally(() => {
        setSpinner(false)
      })
  }, [])

  const columns = [
    { title: 'First Name', field: 'firstName',
      render: rowData => renderRowData(rowData.firstName),
    },
    { title: 'Last Name', field: 'lastName',
      render: rowData => renderRowData(rowData.lastName),
    },
    {
      title: 'Email', field: 'email',
      render: rowData => renderRowData(rowData.email),
    },
    { title: 'Status', field: 'isActive?', 
      render: rowData => renderRowData(rowData.isActive ? "Active" : "Blocked"),
    },
    { 
      title: 'Is Admin?', field: 'isAdmin',  
      render: rowData => renderRowData(rowData.isAdmin ? "Yes" : "No"),
    },
    {
      title: '',
      field: 'link',  
      render: rowData => <OutlinedFab component={MuiRouterLink} to={`/user/${rowData.id}`} underline="none"><i className="fas fa-arrow-right"></i></OutlinedFab>,
      width: '50px',
      sorting: false
    }
  ];

  return (
    <>
      <Nav />

      <div className={classes.tableContainer}>
        
        <Button 
          variant="contained"
          color="primary"
          startIcon={<i className="fas fa-plus"></i>}
          className={classes.button}
          component={MuiRouterLink}
          to="/user"
        >
          Add User
        </Button>

        {spinner 
          ? <CircularProgress className={classes.spinner} size={70} /> 
          : <Table data={users} columns={columns} />
        }

      </div>
    </>
  );
}
